module.exports = __webpack_public_path__ + "img/list-pattern3.8f756ae.svg";